module.exports = __webpack_public_path__ + "static/media/0_400.e8b03522.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/head/0_400.png
// module id = 141
// module chunks = 0